<!--
  Знаки Visa і Mastercard біля кнопки оплати.

  Вимога самих платіжних систем, а не акваєра: Visa Ecommerce Brand Standards
  зобов'язує показувати Visa Brand Mark там, де позначено прийом карток, а
  Mastercard — розміщувати знак на екрані оплати. Картку гість вводить уже на
  сторінці LiqPay/Portmone, але «екраном оплати» в цих правилах є той, де він
  вирішує платити, тобто наш чек із кнопкою «Сплатити».

  На відміну від LiqPayMark, знак не залежить від того, який у закладу акваєр:
  і LiqPay, і Portmone приймають ті самі картки. Умову «чи є взагалі онлайн-
  оплата» вирішує батько — там, де вже стоїть посилання на договір платника.

  Дзеркалить qr-menu/src/components/ui/CardBrandsMark.vue.
-->
<template>
  <span ref="root" class="card-brands" :class="{ 'card-brands--compact': compact }">
    <!-- Visa допускає свій знак лише у Visa Blue, білому або чорному, тож на
         темних темах беремо білу версію. Mastercard читається на будь-якому. -->
    <img
      class="card-brands__visa"
      :src="isDarkSurface ? visaWhite : visaColor"
      alt="Visa"
    />
    <img class="card-brands__mc" :src="mastercard" alt="Mastercard" />
  </span>
</template>

<script>
import { isOnDarkSurface } from "@/utils/surface";
import visaColor from "./visa.svg";
import visaWhite from "./visa-white.svg";
import mastercard from "./mastercard.svg";

export default {
  name: "CardBrandsMark",
  // compact — для футера: там знаки мають бути врівень із дрібним текстом,
  // а не найпомітнішим елементом. Біля кнопки оплати, навпаки, повний розмір.
  props: {
    compact: Boolean,
  },
  data() {
    return { visaColor, visaWhite, mastercard, isDarkSurface: false };
  },
  mounted() {
    // Тему ставлять на body до рендеру сторінок, тож рахуємо один раз.
    this.$nextTick(() => {
      this.isDarkSurface = isOnDarkSurface(this.$el);
    });
  },
};
</script>

<style scoped>
/* Рівна висота знакам не підходить: Visa — це слово з пропорціями ~3:1, а
   Mastercard — символ ~1.6:1, і за однакової висоти символ виглядає роздутим.
   Тому висоти різні, а ширина в обох автоматична — знаки не можна спотворювати.
   gap тримає їх окремими: без проміжку два знаки читаються як один композитний,
   що правила прямо забороняють. */
.card-brands {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.card-brands__visa {
  height: 12px;
  width: auto;
}

.card-brands__mc {
  height: 20px;
  width: auto;
}

.card-brands--compact {
  gap: 8px;
}

.card-brands--compact .card-brands__visa {
  height: 10px;
}

.card-brands--compact .card-brands__mc {
  height: 16px;
}
</style>
